'use client';

import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

type FrontrowPresentation = 'quant' | 'sticker';

interface ProductFrontrowMdWidgetProps {
  id: string;
  variant?: FrontrowPresentation;
}

export function ProductFrontrowMdWidget({
  id,
  variant = 'quant',
}: ProductFrontrowMdWidgetProps) {
  useEffect(() => {
    if (variant !== 'sticker') return;
    if (document.getElementById('frontrow-modal-styles')) return;

    const style = document.createElement('style');
    style.id = 'frontrow-modal-styles';
    style.textContent = `
      .iframe.frontrow {
        display: none;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 99999997;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border: none;
      }
    `;
    document.head.appendChild(style);
  }, [variant]);

  useEffect(() => {
    if (!id) return;

    const existing = Array.from(
      document.head.querySelectorAll<HTMLScriptElement>(
        `script[data-frontrow-product-id][data-frontrow-presentation="${variant}"]`,
      ),
    );
    if (existing.some((el) => el.dataset.frontrowProductId === id)) return;

    const script = document.createElement('script');
    script.async = true;
    script.dataset.frontrowProductId = id;
    script.dataset.frontrowPresentation = variant;
    script.src = `https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=${variant}&product_id=${encodeURIComponent(id)}`;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [id, variant]);

  if (variant === 'sticker') {
    return (
      <Box
        as="iframe"
        title="Frontrow"
        id="frontrow-sticker"
        data-state="max"
        frameBorder="0"
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        src={`https://app.thefrontrowhealth.com/api/widgets?presentation_type=sticker&product_id=${encodeURIComponent(id)}`}
        sx={{
          transform: 'none !important',
          transformOrigin: 'unset !important',
        }}
      />
    );
  }

  return (
    <Box
      as="iframe"
      title="Frontrow"
      className="iframe-frontrow"
      id={`iframe-frontrow-quant-${id}`}
      frameBorder="0"
      sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
      src={`https://app.thefrontrowhealth.com/api/widgets?presentation_type=quant&product_id=${encodeURIComponent(id)}`}
      sx={{
        width: '100%',
        '#frontrow-badge': {
          pos: 'relative',
        },
        '.iframe-frontrow': {
          width: '100%',
          margin: 0,
        },
        '.iframe-modal-frontrow': {
          display: 'none',
          position: 'fixed',
          zIndex: 99999999,
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        },
      }}
    />
  );
}
